<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

// T-186: as telas da Base são telas de trabalho em desktop, e a régua de 1024px do resto das
// Configurações deixava metade do monitor preta com a tabela espremida. A rota pede a largura
// cheia; toda tela que não pedir continua exatamente como era.
const larga = computed(() => Boolean(route.meta?.larguraCheia));
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 pb-8 pt-4 overflow-auto bg-n-surface-1"
    :class="larga ? 'px-8' : 'px-6'"
  >
    <div
      class="flex items-start w-full mx-auto"
      :class="larga ? 'max-w-[1760px]' : 'max-w-5xl'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
